import './utils/global';
import React from 'react';
import ReactDom from 'react-dom';
import { Provider } from 'mobx-react';
import Stores from 'config/Stores';
import Util from 'utils';
import {
  LanguageProvider,
  originalCreateElement,
  originChildren,
  I18nText,
  I18nTextarea,
  I18nInput,
  ToastMessage
} from 'config/language/context';
import './utils/global';
import './utils/sentry';
// 使用PWA时开启
// import * as OfflinePluginRuntime from 'offline-plugin/runtime';
import { ConfirmModal } from 'widget';
import { ShowPopupModal } from 'components/PopupModal';
import { ShowMiniProgramModal } from 'components/MiniProgramModal';

import App from 'widget/App/AppView';
import { LocaleProvider, Toast } from 'antd-mobile';
import config from 'config/Config';
// 引用多语言配置文件
import i18n from 'config/language/config';

import 'function/globalApi';

import { isOldUrl, replaceYofogoDomains } from 'function/yofogoDomains';

window.currentLng = localStorage.getItem('lng') || 'cn';

// // 拦截react组件生成
React.createElement = (...args) => {
  const element = originalCreateElement(...args);
  if (typeof element === 'object' && element !== null && element.type) {
    if (element.type == 'textarea' && element.props.placeholder) {
      return originalCreateElement(I18nTextarea, { ...element.props, ref: element.ref });
    }
    if (element.type == 'input' && element.props.placeholder) {
      return originalCreateElement(I18nInput, { ...element.props, ref: element.ref });
    }
    const children = element.props.children;
    if (typeof children == 'string' && /[\u4e00-\u9fa5]/.test(children)) {
      if (
        element._owner &&
        element._owner.pendingProps &&
        element._owner.pendingProps.pickerItemStyle &&
        element._owner.pendingProps.pickerItemStyle['data-handled']
      ) {
        return element;
      }

      if (element.props['data-security'] || element.props['data-handled']) {
        return element;
      }
      element.props.children = originalCreateElement(I18nText, {
        text: children,
        save: !element.props['data-unsave']
      });
      return element;
    }
    if (Array.isArray(children)) {
      element.props.children = children.map((child) => {
        if (typeof child === 'string' && /[\u4e00-\u9fa5]/.test(child)) {
          if (
            element._owner &&
            element._owner.pendingProps &&
            element._owner.pendingProps.pickerItemStyle &&
            element._owner.pendingProps.pickerItemStyle['data-handled']
          ) {
            return child;
          }

          if (element.props['data-security'] || element.props['data-handled']) {
            return child;
          }
          return originalCreateElement(I18nText, {
            text: child,
            save: !element.props['data-unsave']
          });
        }
        return child;
      });
    }
    return element;
  }
  return element;
};

const OldToastInfo = Toast.info;
const OldToastFail = Toast.fail;
const OldToastSuccess = Toast.success;
const OldToastLoading = Toast.loading;
const OldToastShow = Toast.show;

// 拦截toast
Toast.info = ToastMessage(OldToastInfo);
Toast.fail = ToastMessage(OldToastFail);
Toast.success = ToastMessage(OldToastSuccess);
Toast.loading = ToastMessage(OldToastLoading);
Toast.show = ToastMessage(OldToastShow);

window.Toast = Toast;
// 异常监听
window.sentry && window.sentry.init();

if (
  window.document.location.href.indexOf('sbnh5') != -1 ||
  window.document.location.href.indexOf('nblcdz.cn') != -1 ||
  window.document.location.href.indexOf('sanshengjk.cn') != -1
) {
  let timestamp = Date.parse(new Date());
  Util.getJson(`${config.HOST_JSON}/system/LY.json?v=${timestamp}`).then((res) => {
    localStorage.setItem('globalSms', res.global_sms);
  });
}
try {
  // 通过获取URL参数同步设置header相关参数
  Util.syncUrlParamsToStorage();
} catch (e) {
  console.log('header参数异常', e);
}

window.app = {
  router: null, // 路由跳转用到
  routerGoTo(path) {
    window.app.router.push(path);
  },
  routerRedirect(path) {
    window.app.router.replace(path);
  }
};

window.t = (text) => {
  return text;
};
window.getI18n = i18n.getI18n;
window.in8n = i18n;

window.showConfirmModal = (obj) => ConfirmModal(obj);
window.showPopupModal = (obj) => ShowPopupModal(obj);
window.showMiniProgramModal = (obj) => ShowMiniProgramModal(obj);
Object.defineProperties(window, {
  showConfirmModal: {
    writable: false
  },
  showPopupModal: {
    writable: false
  },
  t: window.t,
  getI18n: window.getI18n
});

if (isOldUrl()) {
  window.showConfirmModal({
    title: '提示',
    content: '此域名暂停服务，点击访问新地址',
    hideLeftText: true,
    onConfirmPress: () => {
      // window.location.href = replaceYofogoDomains();
      window.location.replace(replaceYofogoDomains());
    }
  });
}
if (process.env.NODE_ENV == 'production') {
  // 关闭生产console.log
  console.log = function () {};
} // 微信回调地址处理
let { search, hash } = location;
let noLoginAuto = false;
if (search.length > 0) {
  if (search.indexOf('wechatAuthAuto') >= 0) {
    // 微信授权
    const redirectUrl = `${window.location.origin}${window.location.pathname}#/WechatBackLoginAuth${search}`;
    history.replaceState({}, '', redirectUrl);
    noLoginAuto = true;
  } else if (search.indexOf('wechatAuth') >= 0) {
    // 微信授权
    const redirectUrl = `${window.location.origin}${window.location.pathname}#/wechatPayAuth${search}`;

    history.replaceState({}, '', redirectUrl);
    noLoginAuto = true;
  } else if (search.indexOf('bindWechat') >= 0) {
    // 绑定微信
    const redirectUrl = `${window.location.origin}${window.location.pathname}#/personal/account/bindWechat${search}`;

    history.pushState({}, '绑定微信', redirectUrl);
    noLoginAuto = true;
  } else if (search.indexOf('register') >= 0) {
    const redirectUrl = `${window.location.origin}${window.location.pathname}#/register${search}`;
    history.pushState({}, '注册', redirectUrl);
    noLoginAuto = true;
  } else if (search.indexOf('LYREMPWD') >= 0) {
    const redirectUrl = `${window.location.origin}${window.location.pathname}#/login${search}`;
    history.replaceState({}, '', redirectUrl);
    noLoginAuto = true;
  }
}
// 后管学习成长的专题和课程生成的链接要跳过微信静默
const studyLink = [
  '/learn/course/detail',
  '/learn/thematic/class',
  '/learn/thematic/detail',
  '/learn/PromotionTree/PromotionTreeView',
  '/WorkAuth',
  '/WorkPrivateAuth'
];
const hasStudyLink = studyLink.find((link) => location.href.includes(link));
const { noLoginAuto: isNoLoginAuto } = Util.decodeQuery(location.href);
if (!!hasStudyLink && isNoLoginAuto) {
  const redirectUrl = window.location.href;
  history.replaceState({}, '', redirectUrl);
  noLoginAuto = true;
}
if (sessionStorage.getItem('noNeedAutoLogined')) {
  sessionStorage.setItem('noNeedAutoLogined', '');
  noLoginAuto = true;
}
let tmpDomainList = [
  'h5.fnble.com',
  'h5.nbmqdz.com',
  'h5.uat3.nbmqdz.com',
  'h5.uat5.nbmqdz.com',
  'localhost'
];

if (tmpDomainList.includes(window.location.host)) {
  noLoginAuto = true;
}
const path = window.location.href.split('?')[0].split('#')[1];
if (
  [
    /^\/member\/order\/detail\/DD\d{14}$/,
    /^\/share\/app$/,
    /^\/register$/,
    /^\/shop\/payForm$/,
    /^\/shop\/payForm\/fuiou$/,
    /^\/WorkAuth$/,
    /^\/aiCreation\/aiImageText\/AIImageTextDetail/
  ].find((o) => o.test(path))
) {
  noLoginAuto = true;
}

const changeInternationTitle = async () => {
  // const title = await translation('有享云商');
  document.title = 'YOFOGO'; // 产品要求国际版，写死标题
};

// 当前是否为国际版
const isInternationalized =
  [
    'cxwygj.com',
    'h5.cxwygj.com',
    'intl.yofogo.com',
    'foreign.yofogo.com',
    'intl.fanxinggj.com',
    'foreign.fanxinggj.com',
    'foreignh5.uat3.yofoys.cn'
  ].includes(window.location.host) || window.location.hash.indexOf('isInter') != -1;
// 国际版不走静默登录
if (isInternationalized) {
  changeInternationTitle();
  if (!Util.isXM()) {
    noLoginAuto = true;
  }
} else {
  document.title = '有享云商';
}

if (!localStorage.getItem('noLoginAuto') || localStorage.getItem('noLoginAuto') == 'false') {
  // 未初始化赋值
  localStorage.setItem('noLoginAuto', noLoginAuto || false);
  localStorage.setItem('noLoginAutoInit', '1');
}

const shareId = Util.getQueryString('shareId');
if (shareId) {
  // 全局分享shareId存储
  Util.setLocalCache(config.localStorageKeys.share_link_Id, shareId || '');
}

// DD XY
const fromTeamShareFlag = Util.getQueryString('fromTeamShareFlag') || '';
if (fromTeamShareFlag) {
  Util.setLocalCache('fromTeamShareFlag', fromTeamShareFlag);
}

// 渲染到DOM ID为app的节点上
ReactDom.render(
  <LanguageProvider
    value={{
      t: i18n.t,
      getI18n: i18n.getI18n,
      i18n: i18n
    }}>
    <LocaleProvider locale={undefined}>
      <Provider {...Stores}>
        <App isEntry noLoginAuto={noLoginAuto} />
      </Provider>
    </LocaleProvider>
  </LanguageProvider>,
  document.getElementById('app')
);



// WEBPACK FOOTER //
// ./src/index.js